<template>
  <div class="operation-actions">
    <button
      v-for="item in normalizedItems"
      :key="item.key"
      type="button"
      class="operation-actions__link"
      :class="'operation-actions__link--' + (item.type || 'default')"
      @click="invoke(item)"
    >
      <i v-if="item.icon" :class="item.icon"></i>
      <span>{{ item.label }}</span>
    </button>

  </div>
</template>

<script>
const instances = new Set()
const layoutFrames = new WeakMap()

const requestLayout = (table) => {
  if (!table || typeof table.doLayout !== 'function') return
  const previous = layoutFrames.get(table)
  if (previous) cancelAnimationFrame(previous)
  const frame = requestAnimationFrame(() => {
    layoutFrames.delete(table)
    table.doLayout()
  })
  layoutFrames.set(table, frame)
}

const handleResize = () => {
  instances.forEach(instance => instance.scheduleTableLayout(true))
}

export default {
  name: 'OperationActions',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    normalizedItems() {
      return this.items.filter(item => item && item.visible !== false)
    }
  },
  mounted() {
    instances.add(this)
    if (instances.size === 1) window.addEventListener('resize', handleResize)
    this.$nextTick(() => this.scheduleTableLayout(true))
  },
  updated() {
    this.$nextTick(() => this.scheduleTableLayout())
  },
  beforeDestroy() {
    instances.delete(this)
    if (!instances.size) window.removeEventListener('resize', handleResize)
  },
  methods: {
    invoke(item) {
      if (typeof item.handler === 'function') item.handler()
    },
    findTable() {
      let parent = this.$parent
      while (parent) {
        if (parent.$options && parent.$options.name === 'ElTable') return parent
        parent = parent.$parent
      }
      return null
    },
    scheduleTableLayout(force = false) {
      if (!this.$el) return
      const measuredWidth = Math.ceil(this.$el.scrollWidth)
      if (!force && measuredWidth === this._measuredWidth) return
      this._measuredWidth = measuredWidth
      requestLayout(this.findTable())
    }
  }
}
</script>

<style lang="scss" scoped>
.operation-actions {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  min-width: max-content;
  max-width: none;
  flex-shrink: 0;
  white-space: nowrap;
}

.operation-actions__link {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0;
  margin: 0 12px 0 0;
  color: #1769e8;
  font-family: inherit;
  font-size: 14px;
  line-height: 28px;
  white-space: nowrap;
  border: 0;
  background: transparent;
  cursor: pointer;
  flex-shrink: 0;

  i {
    margin-right: 4px;
  }

  &:hover {
    color: #2b78ef;
  }

  &:last-child {
    margin-right: 0;
  }
}

.operation-actions__link--danger {
  color: #ff4d4f !important;
}

.operation-actions__link--warning,
.operation-actions__link--warn {
  color: #f17609 !important;
}

</style>
